// import { ConfigurationObject } from '../globals/Interfaces';

import { Resources } from '../globals/interfaces';
import { ResourceService } from '../services/resource.service';
import * as Constants from '../globals/constants';
import { PopulationService } from '../services/population.service';
import { TechnologyService } from '../services/technology.service';

/**
 * @internal
 * A base class for production buildings.
 */
export abstract class BuildingClass {
  public reseachMultiplier: number;
  public productionPerMinute: Resources;
  public numberOfBuildings;
  public resourceHandler;
  public technologyService;
  public buildingCosts;
  public buildingJobs;
  public name: string;
  public id: string;
  public settings;

  public produced: Resources;

  public resourceService;
  public populationService;

  public unlocked: boolean;

  protected constructor(resourceService: ResourceService, populationService: PopulationService, technologyService: TechnologyService) {
    this.resourceService = resourceService;
    this.populationService = populationService;
    this.technologyService = technologyService;

    this.unlocked = true;

    this.technologyService.technologyResearched.subscribe(this.updateResearchBonus);
    this.setResearchBonus();

    this.numberOfBuildings = 0;
    this.name = 'Undefined';
    this.produced = {
      food: 0,
      wood: 0,
      population: 0,
      gold: 0,
    };
    this.buildingCosts = {};
    this.buildingJobs = 0;
    this.reseachMultiplier = 1;
  }

  public tick(timePassed) {
    this.produce(timePassed);
    this.resourcesProduced();
  }

  public produce(timePassed) {

  }

  public resourcesProduced() {

  }

  public initBuilding(name: string, id: string, buildingSettings: any) {
    this.name = name;
    this.id = id;
    this.settings = buildingSettings;
    this.reset();
  }

  public reset() {
    this.numberOfBuildings = this.settings.STARTING_AMOUNT;
    Constants.OWNED_BUILDINGS[this.id] = this.numberOfBuildings;
    this.buildingCosts = this.settings.COSTS;
    this.buildingJobs = this.settings.JOBS;
    this.populationService.addAvailableJobs(this.buildingJobs * this.settings.STARTING_AMOUNT);
    this.unlocked = this.unlock();
  }

  public addBuilding() {
    this.numberOfBuildings++;
    Constants.OWNED_BUILDINGS[this.id] = this.numberOfBuildings;
    this.populationService.addAvailableJobs(this.buildingJobs);
  }

  public getBuildingCosts() {
    return this.buildingCosts;
  }

  public removeBuilding() {
    this.numberOfBuildings++;
    if (this.numberOfBuildings < 0 ) {
      this.numberOfBuildings = 0;
    }
  }

  private updateResearchBonus = () => {
    this.setResearchBonus();
    this.unlocked = this.unlock();
  }

  public unlock(): boolean {
    return true;
  }

  public setResearchBonus() {
    this.reseachMultiplier = 1;
  }

  public loadBuilding(amount) {
    this.numberOfBuildings = 0;
    let i;
    for (i = 0; i < amount; i++) {
      this.addBuilding();
    }
  }

  public getBuildingImage() {
    return 'https://thumbs.dreamstime.com/z/wooden-house-vector-drawing-cozy-wood-plank-barn-facade-isolated-white-backdrop-retro-loghouse-abode-aged-reed-roof-95834182.jpg';
  }
}
